import { render, staticRenderFns } from "./PrimaryContact.vue?vue&type=template&id=7b2a6878&scoped=true&"
import script from "./PrimaryContact.vue?vue&type=script&lang=js&"
export * from "./PrimaryContact.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryContact.vue?vue&type=style&index=0&id=7b2a6878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2a6878",
  null
  
)

export default component.exports